<label [ngClass]="{ switch: true, slider: true, yes: value, no: !value }">
  <input #input type="checkbox" (change)="updateBoolValue($event)" />
  <span class="yesValue">Yes</span>
  <span class="noValue">No</span>
</label>
